import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreSiteStatsModule } from '@freelancer/datastore/collections';
import { UiModule } from '@freelancer/ui';
import { LandingPageSharedModule } from '../landing-page-shared.module';
import { BenefitsComponent } from './benefits.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreSiteStatsModule,
    LandingPageSharedModule,
    UiModule,
  ],
  declarations: [BenefitsComponent],
  exports: [BenefitsComponent],
})
export class BenefitsModule {}
